const THREE = require('three');

// const font = import('three/examples/fonts/helvetiker_regular.typeface.json');

import fontJSON from 'three/examples/fonts/helvetiker_regular.typeface.json';


const CYL_LENGTH = 5;
const COOR_LENGTH = 7;
const HALF_CYL_LENGTH = 2.5;
const CHAR_DISTANCE = 6;
const CYL_WIDTH = 0.2;
const ARROW_WIDTH = 0.4;
const ARROW_LENGTH = 0.8;
const SPHERE_RADIUS = 0.6;
const POLIGON_NUMBER = 32;

const YELLOW = 0xDADA00;
const RED = 0xDA0000;
const BLUE = 0x009FFE;
const GREEN = 0x007800;

const PI_DIV_2 = Math.PI / 2;

class Axis extends THREE.Object3D {

    getSphereMesh() {
        const geometry = new THREE.SphereGeometry(SPHERE_RADIUS, POLIGON_NUMBER, POLIGON_NUMBER);
        const material = new THREE.MeshPhongMaterial({color: RED});
        return new THREE.Mesh(geometry, material);
    }

    getPointerMesh(rotateX, rotateZ) {
        let rotateFunction, color, x = 0, y = 0, z = 0, x1 = 0, y1 = 0, z1 = 0;
        if (rotateX) {
            rotateFunction = 'rotateX';
            color = YELLOW;
            y = ARROW_WIDTH;
            z = ARROW_LENGTH;
            z1 = CYL_LENGTH;
        } else if (rotateZ) {
            rotateFunction = 'rotateZ';
            color = GREEN;
            x = ARROW_WIDTH;
            z = ARROW_LENGTH;
            x1 = CYL_LENGTH;
        } else {
            color = BLUE;
            y = ARROW_WIDTH;
            z = ARROW_LENGTH;
            y1 = CYL_LENGTH;
        }
        const geometry = new THREE.CylinderGeometry(x, y, z);
        const material = new THREE.MeshPhongMaterial({color: color});
        let mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(x1, y1, z1);
        if (rotateFunction) {
            mesh[rotateFunction](PI_DIV_2)
        }
        return mesh;
    }

    getCylMesh(rotateX, rotateZ) {
        let rotateFunction, color, x = 0, y = 0, z = 0;
        if (rotateX) {
            rotateFunction = 'rotateX';
            color = YELLOW;
            z = HALF_CYL_LENGTH;
        } else if (rotateZ) {
            color = GREEN;
            rotateFunction = 'rotateZ';
            x = HALF_CYL_LENGTH;
        } else {
            color = BLUE;
            y = HALF_CYL_LENGTH;
        }
        const geometry = new THREE.CylinderGeometry(CYL_WIDTH, CYL_WIDTH, CYL_LENGTH);
        const material = new THREE.MeshPhongMaterial({color: color});
        let mesh = new THREE.Mesh(geometry, material);
        mesh.position.set(x, y, z);
        if (rotateFunction) {
            mesh[rotateFunction](-PI_DIV_2);
        }
        return mesh;
    }

    getArrowMesh(rotateX, rotateZ) {
        return [this.getCylMesh(rotateX, rotateZ), this.getPointerMesh(rotateX, rotateZ), this.getCharMesh(rotateX, rotateZ)];
    }

    getCharMesh(rotateX, rotateZ) {
        const options = {
          size: 1,
          height: 0.1,
          weight: 'normal',
          font: new THREE.Font(fontJSON),
          style: 'normal',
          bevelThickness: 0.1,
          bevelSize: 0.1,
          bevelSegments: 12,
          bevelEnabled: true,
          curveSegments: 12,
          steps: 1
        };

        let rotateFunction, color, x = 0, y = 0, z = 0, text = '';
        if (rotateX) {
            rotateFunction = 'rotateX';
            color = YELLOW;
            text = 'Z';
            z = CHAR_DISTANCE;
        } else if (rotateZ) {
            color = GREEN;
            rotateFunction = 'rotateZ';
            text = 'Y';
            x = CHAR_DISTANCE;
        } else {
            text = 'X';
            color = BLUE;
            y = CHAR_DISTANCE;
        }
        const geometry = new THREE.TextGeometry(text, options);
        const material = new THREE.MeshPhongMaterial({color: color});

        let mesh = new THREE.Mesh(geometry, material);
        this[text] = mesh;
        mesh.position.set(x, y, z);
        if (rotateFunction) {
          mesh[rotateFunction](-PI_DIV_2);
        }
        return mesh;
    }

    constructor (scene, ratio) {
        super();
        this.ratio = ratio;
        this.scene = scene;
        // this.drawLetters();
        let axis = new THREE.Object3D();
        const [cylY, pointerY, charY] = this.getArrowMesh();
        const [cylX, pointerX, charX] = this.getArrowMesh(true);
        const [cylZ, pointerZ, charZ] = this.getArrowMesh(undefined, true);
        axis.add(this.getSphereMesh(), cylY, pointerY, cylX, pointerX, cylZ, pointerZ, charX, charZ, charY);

        const axisPointer = new THREE.Object3D();

        axisPointer.position.set(-20 * this.ratio, -19, -60);
        this.add(axisPointer);
        this.axis = axis;
        this.scene.add(axis);
    }

    setPosition(camera) {
        this.position.set(camera.position.x, camera.position.y, camera.position.z);
        const cameraRotation = camera.rotation.toVector3();
        this.rotation.setFromVector3(cameraRotation);
        this.Y.rotation.setFromVector3(cameraRotation);
        this.Z.rotation.setFromVector3(cameraRotation);
        this.X.rotation.setFromVector3(cameraRotation);
        this.children[0].rotation.setFromVector3(new THREE.Vector3());
        this.scene.updateMatrixWorld();
        this.updateMatrixWorld();
        this.children[0].updateMatrixWorld();
        const pointerPosition = this.children[0].getWorldPosition();
        this.axis.position.set(pointerPosition.x, pointerPosition.y, pointerPosition.z);
    }
}

export default Axis;



// WEBPACK FOOTER //
// ./client/app/common/model-view/axis.js